export const UI_6_2_popup_tableRow_sink = [
  [
    {
      cellName: "매도공장",
      id: "buyPlantInloName",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래기간",
      id: "calcYm",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래량",
      id: "trnsVol",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "engUnit",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래단가",
      id: "unitPrice",
      row: 1,
      col: 1,
    },
    {
      cellName: "결산금액",
      id: "trnsVolChrg",
      row: 1,
      col: 1,
    },
  ]
];


export const UI_6_2_popup_tableRow_source = [
  [
    {
      cellName: "매수공장",
      id: "sellPlantInloName",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래기간",
      id: "calcYm",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래량",
      id: "trnsVol",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "engUnit",
      row: 1,
      col: 1,
    },
    {
      cellName: "거래단가",
      id: "unitPrice",
      row: 1,
      col: 1,
    },
    {
      cellName: "결산금액",
      id: "trnsVolChrg",
      row: 1,
      col: 1,
    },
  ]
]